import {
  List,
  Datagrid,
  ReferenceField,
  DateField,
  BooleanField,
  NumberField,
  ArrayField,
  ReferenceInput,
  BooleanInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserCourseList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <ReferenceInput key="filter-courseId" source="courseId" reference="courses" />,
      <ReferenceInput key="filter-userId" source="userId" reference="users" />,
      <BooleanInput key="filter-isCompleted" source="isCompleted" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField key="field-courseId" source="courseId" reference="courses" />
      <ReferenceField key="field-userId" source="userId" reference="users" />
      <ArrayField source="sections">
        <Datagrid>
          <ReferenceField key="field-sectionId" source="sectionId" reference="sections" />
          <DateField source="startedAt" />
          <DateField source="completedAt" />
          <BooleanField source="isPassed" />
          <NumberField source="minTimeToProcessInHours" />
          <ReferenceField source="examId" reference="exams" />
          <ReferenceField source="userExamId" reference="userExams" />
        </Datagrid>
      </ArrayField>
      <BooleanField source="isCompleted" />
      <DateField source="completedAt" />
      <ReferenceField key="field-finalExamId" source="finalExamId" reference="exams" />
    </Datagrid>
  </List>
)

export const UserCourseShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField key="field-courseId" source="courseId" reference="courses" />
      <ReferenceField source="userId" reference="users" />
      <ArrayField source="sections">
        <Datagrid>
          <ReferenceField source="sectionId" reference="sections" />
          <DateField source="startedAt" />
          <DateField source="completedAt" />
          <BooleanField source="isPassed" />
          <NumberField source="minTimeToProcessInHours" />
          <ReferenceField source="examId" reference="exams" />
          <ReferenceField source="userExamId" reference="userExams" />
        </Datagrid>
      </ArrayField>
      <BooleanField source="isCompleted" />
      <DateField source="completedAt" />
      <ReferenceField key="field-finalExamId" source="finalExamId" reference="exams" />
    </SimpleShowLayout>
  </Show>
)
